import apiClient from '@/services/axios'
import { transformIntoQuery } from '@/utils/pagination'

class PromoCodeService {
  constructor() {
    this.$api = apiClient
  }

  getCodes(pagination) {
    const query = transformIntoQuery(pagination)
    return this.$api.get(`/seller/promo${query}`)
  }

  getCodeById(id) {
    return this.$api.get(`/seller/promo/${id}`)
  }

  createCode(payload) {
    return this.$api.post('/seller/promo', payload)
  }

  editProducts(id, payload) {
    return this.$api.put(`/seller/promo/product/${id}`, payload)
  }

  editPeriod(id, payload) {
    return this.$api.put(`/seller/promo/${id}`, payload)
  }

  deactivateCode(id) {
    return this.$api.put(`/seller/promo/deactivate/${id}`)
  }
}

export default new PromoCodeService()
